@use '@design/design-tokens/border-radius/border-radius' as *;

.styledButtonGroup {
  width: fit-content;
  white-space: nowrap;
  border-radius: 10px;

  [data-button-group-item] {
    @include border-radius-r2;
  }
}

.secondary {
  background-color: var(--surface-active);
  border: 0;
  padding: 2px;

  [data-button-group-item] {
    padding: 8px;

    &:hover {
      background-color: var(--surface-hover);
    }
  }
}

.wrapper {
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    fill: var(--icon-soft);

    path {
      fill: var(--icon-soft);
    }
  }
}

.active {
  svg {
    fill: var(--icon-primary);

    path {
      fill: var(--icon-primary);
    }
  }
}
